export const EVL_GOAL_TYPES = [
    {key: "Predge", name: "Гаров"},
    {key: "Sale", name: "Сотиш учун"},
    {key: "DeterminingValue", name: "Тугатиш қиймати"},
    {key: "FormationStatutoryFund", name: "Устав жамғармасини шакллантириш"},
    {key: "Losses", name: "Етказилган зарар"},
    {key: "Privatization", name: "Хусусийлаштириш"},
    {key: "Zero", name: "0 кийматда хусусийлаштириш"},
    {key: "Investment", name: "Инвестиция қийматини аниқлаш"},
    // {key: "DeterminationMarketValue", name: "Бозор қийматини аниқлаш"},
    {key: "Inheritance", name: "Мерос"},
    {key: "BusinessDeterminingValue", name: "Бизнес қийматини аниқлаш"},
    {key: "AcceptToBalance", name: "Балансга кабул килиш"},
    {key: "DeterminationValue", name: "Қийматини аниқлаш"}
];

export const EVL_VALUE_TYPES = [
    {key: "Market", name: "Бозор қиймати"},
    {key: "TheEnd", name: "Тугатиш қиймати"}
];

export const EVL_PROPERTY_TYPES = [
    {key: "Private", name: "Хусусий мулк"},
    {key: "Government", name: "Давлат мулки"},
    {key: "Society", name: "Жамият мулки"},
    {key: "Community", name: "Жамоа мулки"}
];

export const BUSINESS_COEFFICIENTS = [
    1.081,
    1.100,
    1.168,
    1.262,
    1.365,
    1.476,
    1.598,
];

export const EARTHQUAKE_POINTS = [7, 8, 9];

export const CADASTRE_BULDING_CATEGORIES = [
    {code: 'a', name: 'а'},
    {code: 'b', name: 'б'},
    {code: 'v', name: 'в'},
    {code: 'g', name: 'г'},
    {code: 'd', name: 'д'},
    {code: 'e', name: 'е'},
    {code: 'j', name: 'ж'},
    {code: 'z', name: 'з'},
    {code: 'i', name: 'и'},
    {code: 'y', name: 'й'},
    {code: 'k', name: 'к'},
    {code: 'l', name: 'л'},
    {code: 'm', name: 'м'},
    {code: 'n', name: 'н'},
    {code: 'o', name: 'о'},
    {code: 'p', name: 'п'},
    {code: 'r', name: 'р'},
    {code: 's', name: 'с'},
    {code: 't', name: 'т'},
    {code: 'u', name: 'у'},
    {code: 'f', name: 'ф'},
    {code: 'x', name: 'х'}
];

export const CAPITAL_GROUPS = ['I', 'II', 'III', 'IV', 'V'];

export const EVL_METHOD_TYPES = [
    {key: "Coincidental", name: "Турдош метод"},
    {key: "Simple", name: "Оддий метод"}
];

export const EVL_PRICE_TYPES = [
    {key: "NationalCurrency", name: "Миллий валюта"},
    {key: "ForeignCurrency", name: "Хорижий валюта"}
];